<template>
  <div>
    <approve-list-setting :loading="isMainLoading" @onSearch="getApproveTasksSettingHistoryByMarket"></approve-list-setting>
  </div>
</template>

<script>
import ApproveListSetting from "../../components/ApproveListSettingHistory.vue";
export default {
  components: { ApproveListSetting },
  props: {
    isMainLoading: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    getApproveTasksSettingHistoryByMarket(form) {
      this.$emit("onGetApproveTasksSettingHistoryByMarket",form);
    }
  }
};
</script>

<style>
</style>